// extracted by mini-css-extract-plugin
module.exports = {"goLiveButton":"LiveCamButton_goLiveButton__LxGT0"};